import { createIcon } from '../icons/utils';

/**
 * Letter glyph: an envelope/document card with a heart, rendered in the teal
 * accent. Its colors are baked into the SVG (every shape carries an explicit
 * `fill`/`stroke`), so it renders the same regardless of the priority
 * `className` the lane passes.
 */
export const LetterIcon = createIcon(
  ({ ref, className, innerClassName, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.8333 1.66663H4.16667C3.24619 1.66663 2.5 2.49573 2.5 3.51848V16.4814C2.5 17.5042 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5042 17.5 16.4814V3.51848C17.5 2.49573 16.7538 1.66663 15.8333 1.66663Z"
        className={innerClassName}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.998 5.17657C9.41486 4.52729 8.44243 4.35264 7.71179 4.94719C6.98115 5.54173 6.87828 6.53579 7.45206 7.23896C8.02583 7.94213 9.998 9.58329 9.998 9.58329C9.998 9.58329 11.9702 7.94213 12.5439 7.23896C13.1177 6.53579 13.0274 5.53548 12.2842 4.94719C11.541 4.35889 10.5811 4.52729 9.998 5.17657Z"
        className={innerClassName}
      />
      <path
        d="M7.5 15.4166H12.5M5.83333 12.5H14.1667M4.16667 1.66663H15.8333C16.7538 1.66663 17.5 2.49573 17.5 3.51848V16.4814C17.5 17.5042 16.7538 18.3333 15.8333 18.3333H4.16667C3.24619 18.3333 2.5 17.5042 2.5 16.4814V3.51848C2.5 2.49573 3.24619 1.66663 4.16667 1.66663ZM9.998 5.17657C9.41486 4.52729 8.44243 4.35264 7.71179 4.94719C6.98115 5.54173 6.87828 6.53579 7.45206 7.23896C8.02583 7.94213 9.998 9.58329 9.998 9.58329C9.998 9.58329 11.9702 7.94213 12.5439 7.23896C13.1177 6.53579 13.0274 5.53548 12.2842 4.94719C11.541 4.35889 10.5811 4.52729 9.998 5.17657Z"
        className={innerClassName}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'LetterIcon', defaultSize: 20, classNameBase: '' },
);
